import { Navigate } from "react-router";
import { Button } from "@/components/ui/button";
import { Page } from "@/components/ui/page";
import { EmptyState, Panel } from "@/components/ui/panel";
import { useMe } from "@/lib/session";
import { Link } from "react-router";

/** Sends people to their office; admins without offices land on office management. */
export function HomePage() {
  const { data: me } = useMe();
  if (!me) return null;
  if (me.offices[0]) return <Navigate to={`/offices/${me.offices[0].id}`} replace />;
  if (me.user.platformRole === "admin") return <Navigate to="/admin/offices" replace />;
  return (
    <Page art="feature-keywords-discovery" mood="empty" title="ようこそ">
      <Panel>
        <EmptyState photo="empty-home" title="担当の事務所がまだありません">
          管理者が事務所への割り当てを行うと、ここに表示されます。
        </EmptyState>
        <div className="text-center"><Button asChild variant="outline"><Link to="/account">アカウント設定</Link></Button></div>
      </Panel>
    </Page>
  );
}
